

import React from 'react';
import { ComplexRoute } from 'router/components/Routes/Routes';
import { Navigate } from 'react-router-dom';
import PersonalInfo from './pages/PersonalInfo';
import Settings from './pages/Settings';

export default [
  {
    label: 'personal-info',
    path: 'personal-info',
    element: PersonalInfo,
  },
  {
    label: 'settings',
    path: 'settings',
    element: Settings,
  },
  {
    index: true,
    element: <Navigate to="personal-info" />,
  },
] as Array<ComplexRoute>;
